// extracted by mini-css-extract-plugin
export default {"authLeftContent":"authLayout_authLeftContent__Xj+9B"};